import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { renderComponentOrElement } from '../utils/helpers/component.js';
import { Grid } from '../Grid/Grid.web.js';
import { header, content, left, center, right } from './styles.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var headerRender = function headerRender(props, colorProps) {
  var leftComponent = props.leftComponent,
    centerComponent = props.centerComponent,
    rightComponent = props.rightComponent;
  return /*#__PURE__*/React.createElement(header, _extends({
    "data-test": "elemental-Header"
  }, colorProps), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(content, null, /*#__PURE__*/React.createElement(left, null, leftComponent ? renderComponentOrElement(leftComponent, colorProps, true) : null), /*#__PURE__*/React.createElement(center, null, centerComponent ?
  /**
   * With new color standards logo is optimisticGreen, and everyting else is forestGreen
   * Thus this a bit hacky change here
   */
  renderComponentOrElement(centerComponent, _objectSpread(_objectSpread({}, colorProps), {}, {
    highlightColor: colorProps.centerComponentColor
  })) : null), /*#__PURE__*/React.createElement(right, null, rightComponent ? renderComponentOrElement(rightComponent, colorProps, true) : null))));
};

export { headerRender };
